import {
	requests
}from "../../../api/agent"

export default {
	getInternationalPhoneCodes : (values) => requests.getWithParams("/phone/getInternationalPhoneCodes", values),
	sendCode                   : (values) => requests.post("/phone/sendCodeToPhone", values),
	changeNumber               : (values) => requests.post("/phone/changeMobilePhone", values),
	preChecking                : (values) => requests.post("/phone/preChecking", values),
	checkPhoneCode             : (values) => requests.post("/phone/checkPhoneCode", values)
}
